import { FC, memo } from 'react';
import { useRedeemStatuses } from '../hooks';

export const RedeemStatusCell: FC<{
  status: string;
}> = memo(({ status }) => {
  const redeemStatuses = useRedeemStatuses();
  return redeemStatuses[status] || status;
});
